import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
};

const DIRECTION_STYLES = {
  [DIRECTIONS.CENTER]: '',
  [DIRECTIONS.LEFT]: 'rounded-l-4',
  [DIRECTIONS.RIGHT]: 'rounded-r-4',
};

const Range = ({ direction, className }) => (
  <div
    className={twMerge(
      'h-2 w-1/3 rounded-3 content-empty',
      DIRECTION_STYLES[direction],
      className
    )}
  />
);

Range.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  direction: PropTypes.oneOf(Object.values(DIRECTIONS)),
};

export default Range;
